// extracted by mini-css-extract-plugin
export default {"close":"Dialog_close__YyT04","opacity":"Dialog_opacity__AOWG3","withoutActions":"Dialog_withoutActions__y9N-8"};